import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { BillsToPayService } from 'src/app/service/bills-to-pay/bills-to-pay.service';
import { CreditCardService } from 'src/app/service/credit-card/credit-card.service';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-parcels',
  templateUrl: './update-parcels.component.html',
  styleUrls: ['./update-parcels.component.css'],
})
export class BillsToPayUpdateParcelsComponent implements OnInit {
  billsToPayForm: FormGroup;
  loading: boolean = true;
  messageError: string = '';
  id: number;

  constructor(
    private creditCardService: CreditCardService,
    private service: BillsToPayService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });
  }

  ngOnInit(): void {
    this.createForm();
    this.setForm();
  }

  setForm() {
    this.service.getBillToPay(this.id).subscribe(
      (data) => {
        this.billsToPayForm.controls.value.setValue(data.value.toString());

        this.billsToPayForm.controls.paymentMethod.setValue(data.paymentMethod);

        if (data.parcels) {
          this.billsToPayForm.controls.frequency.setValue(
            this.getFrequency(data.dueDate, data.parcels[0].dueDate)
          );

          this.billsToPayForm.controls.parcAmount.setValue(data.parcels.length);

          this.parcels.clear();

          this.loading = false;

          data.parcels.forEach((item, i) => {
            this.parcels.push(
              this.fb.group({
                id: [item.id],
                number: [item.number],
                value: [item.value || this.parcelValue()],
                paidValue: [item.paidValue],
                paid: [item.paid],
                bankCheckNumber: [
                  item.bankCheckNumber || '',
                  [Validators.maxLength(10)],
                ],
                dueDate: [this.formatDate(item.dueDate)],
              })
            );
            this.parcelPaidChanged(i, item.paid);
          });
        }
      },
      (error) => {
        this.loading = false;
        Swal.fire('Erro', 'Não foi possível Buscar As parcelas!', 'error');
      }
    );
  }

  createForm() {
    this.billsToPayForm = this.fb.group({
      value: [''],
      dueDate: [''],
      parcAmount: [null],
      frequency: [''],
      paymentMethod: [''],
      parcels: this.fb.array([]),
    });
  }

  get parcels() {
    return this.billsToPayForm.get('parcels') as FormArray;
  }

  onlyNumber(event: any): void {
    event.key.match(/[^0-9]/) && event.preventDefault();
  }

  parcelValue() {
    const { value, parcAmount } = this.billsToPayForm.getRawValue();

    if (!value || !parcAmount) return '';

    return value / parcAmount;
  }

  onSubmit() {
    this.messageError = '';

    if (this.billsToPayForm.valid) {
      const billsToPay = this.billsToPayForm.getRawValue();

      billsToPay.id = this.id;

      this.service.updateParcels(billsToPay).subscribe(
        (data) => {
          this.loading = false;
          Swal.fire(
            'Editada',
            'Parcelas editadas com sucesso!!',
            'success'
          ).then((result) => {
            if (result.value) {
              this.router.navigate(['financial/bills-to-pay']);
            }
          });
        },
        (error) => {
          this.loading = false;
          this.setErrors(error.error.errors);
          Swal.fire(
            'Erro ao editar',
            'Não foi possível editar conta a pagar!',
            'error'
          );
        }
      );
    }
  }

  setErrors(errors) {
    errors.forEach((erro) => {
      switch (erro.fieldName) {
        case 'email':
          this.billsToPayForm.controls.email.setErrors({
            invalid: erro.message,
          });
          break;
        case 'name':
          this.billsToPayForm.controls.name.setErrors({
            invalid: erro.message,
          });
          break;
        case 'role':
          this.billsToPayForm.controls.role.setErrors({
            invalid: erro.message,
          });
          break;
        case 'birthDate':
          this.billsToPayForm.controls.birthDate.setErrors({
            invalid: erro.message,
          });
          break;
        case 'phone':
          this.billsToPayForm.controls.phone.setErrors({
            invalid: erro.message,
          });
          break;
        case 'login':
          this.billsToPayForm.controls.login.setErrors({
            invalid: erro.message,
          });
          break;
        default:
          this.messageError += `${erro.message}\n`;
      }
    });
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return [year, month, day].join('-');
  }

  getFrequency(firstDate, secondDate) {
    const date1 = new Date(firstDate);
    const date2 = new Date(secondDate);
    const year1 = date1.getFullYear();
    const year2 = date2.getFullYear();
    const month1 = date1.getMonth();
    const month2 = date2.getMonth();
    const diffTime = Math.abs(date2.getTime() - date1.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    const diffMonths = (year2 - year1) * 12 + (month2 - month1);

    let frequency = '';

    switch (diffDays) {
      case 1:
        frequency = 'days';
        break;
      case 7:
        frequency = 'weeks';
        break;
      case 14:
      case 15:
        frequency = 'fortnights';
        break;
      default:
        frequency = '';
    }

    if (!frequency) {
      switch (diffMonths) {
        case 1:
          frequency = 'months';
          break;
        case 2:
          frequency = 'bimonthly';
          break;
        case 3:
          frequency = 'quarters';
          break;
        case 6:
          frequency = 'semesters';
          break;
        case 12:
          frequency = 'years';
          break;
        default:
          frequency = '';
      }
    }

    return frequency;
  }

  getAllErrors(form: FormGroup | FormArray): { [key: string]: any } | null {
    let hasError = false;
    const result = Object.keys(form.controls).reduce((acc, key) => {
      const control = form.get(key);
      const errors =
        control instanceof FormGroup || control instanceof FormArray
          ? this.getAllErrors(control)
          : control.errors;
      if (errors) {
        acc[key] = errors;
        hasError = true;
      }
      return acc;
    }, {} as { [key: string]: any });
    return hasError ? result : null;
  }

  parcelPaidChanged(i: number, paid: boolean) {
    if (paid) {
      this.parcels.controls[i]
        .get('paidValue')
        .setValidators([Validators.required]);
    } else {
      this.parcels.controls[i].get('paidValue').clearValidators();
    }
    this.parcels.controls[i].get('paidValue').updateValueAndValidity();
  }
}
